import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    components: {
        MuiContainer: {
            styleOverrides: {
                root:{
                    maxWidth: "1320px !important",
                }
            }
        }
    },
    typography: {
        fontFamily: "Raleway, sans-serif",
    }
})
export default theme;